export const emphasis = {
  high: 0.87,
  medium: 0.6,
  low: 0.38,
  pure: 1,
};
